import { authenticatedApi } from '../api';

export const API_CHANNEL_VIDEOS_PATH = '/channel/videos';

export const createVideo = async ({ channelId, video }) => authenticatedApi.post(
	`${API_CHANNEL_VIDEOS_PATH}/toChannelById/${channelId}`,
	video,
);

export const deleteVideo = (videoId) => authenticatedApi.delete(
	`${API_CHANNEL_VIDEOS_PATH}/${videoId}`,
);

export const fetchVideos = (
	channelId,
	mode,
	itemsPerPage,
	currentPage,
) => authenticatedApi.get(
	`${API_CHANNEL_VIDEOS_PATH}`,
	{
		params: {
			channelId,
			mode,
			itemsPerPage,
			currentPage,
		},
	},
);

export const fetchVodByHashtag = (hashtag) => authenticatedApi.get(
	`${API_CHANNEL_VIDEOS_PATH}/vod/byhashtag/${hashtag}`,
);

export const requestVodById = async (id, requiredAccess) => authenticatedApi.post(
	`${API_CHANNEL_VIDEOS_PATH}/request/${id}`,
	{ requiredAccess },
);

export const fetchVodById = (id) => authenticatedApi.get(`${API_CHANNEL_VIDEOS_PATH}/${id}`);

export const updateVideo = (video) => authenticatedApi.put(
	API_CHANNEL_VIDEOS_PATH,
	video,
);

export const cloneVideo = ({ cloneFromVideoId, videoData }) => authenticatedApi.post(
	`${API_CHANNEL_VIDEOS_PATH}/clone/${cloneFromVideoId}`,
	videoData,
);

export const buyVodAccess = (id) => authenticatedApi.post(`${API_CHANNEL_VIDEOS_PATH}/${id}/access`);

export const getDownloadLink = (videoId) => authenticatedApi.get(`${API_CHANNEL_VIDEOS_PATH}/download/${videoId}`);

export const viewVideo = (id, watchId) => authenticatedApi.put(
	`${API_CHANNEL_VIDEOS_PATH}/${id}/viewed`,
	{
		watchId,
	},
);

export const sendVideoWatchTime = (
	vodId,
	watchId,
	playStartTime,
	playEndTime,
) => authenticatedApi.post(
	`${API_CHANNEL_VIDEOS_PATH}/${vodId}/watchTime`,
	{
		playStartTime,
		playEndTime,
		watchId,
	},
);

export const likeVideo = (params) => authenticatedApi.post(
	`${API_CHANNEL_VIDEOS_PATH}/like`,
	params,
);
